









































import { Component, Prop, Vue } from "vue-property-decorator";
import { siteConfig } from "@/SiteConfig.ts";
import { getImgUrl } from "@/helper/ImgUrlHelper.ts";
import AppContainerComponent from "@/components/AppContainerComponent.vue";
import FooterComponent from '@/components/FooterComponent.vue';

@Component({
  components: {
    AppContainerComponent,
    FooterComponent
  }
})
export default class HomeComponent extends Vue {
  private mainText = siteConfig.mainText;
  private mainTextColor = siteConfig.mainTextColor;
  private mapLink = siteConfig.mapLink;
  private addrLine1 = siteConfig.addrLine1;
  private addrLine2 = siteConfig.addrLine2;
  private addrLine3 = siteConfig.addrLine3;
  private emailId = siteConfig.emailId;
  private contactNo = siteConfig.contactNo;
  private imgLink = siteConfig.imgLink;

  private style: HTMLStyleElement | undefined = undefined;

  private getImgUrl = getImgUrl;

  public mounted() {
    this.style = document.createElement("style");
    this.style.innerHTML =
      '@media (min-width: 1200px) { .app-wrapper.app-wrapper { background-image: url("' +
      getImgUrl('bg-image.png') + '"), url("' + getImgUrl('logo-bg.png') + '"); background-position: top right, top left; } }';
    document.body.appendChild(this.style);
  }
  public destroyed() {
    if (this.style) {
      this.style.remove();
    }
  }
}
